import $ from 'jquery';

const DetailModules = function () {
  // ENTRY CHECK AGREE
  if (document.getElementById("agree") != null && document.getElementById("entry")) {
    const check = document.getElementById("agree");
    const btn = $('#entry');

    $(window).on('load', () => {
      entryCheck();
    })
    check.addEventListener('change', function () {
      entryCheck();
    });
    function entryCheck() {
      if (check.checked) {
        $(btn).removeClass('is-disabled');
      } else {
        $(btn).addClass('is-disabled');
      }
    }
  }
  // FIGURE CAPTION SET
  $(window).on('load', () => {
    const $els = $('img[title]');
    $els.each((i, el) => {
      $(el).wrap('<figure>')
      $(el).after(`<figcaption>${$(el).attr('title')}</figcaption>`);
    })
  })
}

export default DetailModules;


// WEBPACK FOOTER //
// ./src/recruit/js/detail.js